var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "ccEmail",
      "centered": "",
      "size": "md",
      "close-on-backdrop": "",
      "hide-footer": "",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.handleModalShown
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "addccEmail-header"
        }, [_c('div', {
          staticClass: "text-center email-title-cc"
        }, [_c('h4', [_vm._v("Email Categories")])])])];
      },
      proxy: true
    }])
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "addRep-form ccEmail-form"
  }, [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Email:")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.email
    }
  })]), _c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Select Email Categories:")]), _c('div', {
    staticClass: "checkbox-group"
  }, _vm._l(_vm.emailDomains, function (domain) {
    return _c('div', {
      key: domain.value,
      staticClass: "custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedDomains,
        expression: "selectedDomains"
      }],
      attrs: {
        "type": "checkbox",
        "id": "checkbox-".concat(domain.value)
      },
      domProps: {
        "value": domain.value,
        "checked": Array.isArray(_vm.selectedDomains) ? _vm._i(_vm.selectedDomains, domain.value) > -1 : _vm.selectedDomains
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.selectedDomains,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = domain.value,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && (_vm.selectedDomains = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedDomains = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedDomains = $$c;
          }
        }
      }
    }), _c('label', {
      staticClass: "custom-label",
      attrs: {
        "for": "checkbox-".concat(domain.value)
      }
    }, [_vm._v(" " + _vm._s(domain.text) + " ")]), _c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": domain.description
      }
    }, [_c('i', {
      staticClass: "fas fa-info-circle",
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "10px",
        "color": "#007bff"
      }
    })])]);
  }), 0), _c('p', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" By selecting any of the checkboxes, you will be included in CC emails for the selected email categories. ")])]), _c('div', {
    staticClass: "form-group text-center mb-3 mt-3"
  }, [_c('b-button', {
    staticClass: "univ-btn px-4 py-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Apply ")])], 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }